import React from 'react';

import { Multiple } from '../../../multiple-text-blurb-for-grid';
import { messages } from '../messages';
import { useEntitiesFulfillmentPlanProperty } from '../../../../hooks/entities/selectors/fulfillment-plans';
import { PremiumProgramTags } from '../../../premium-programs/premium-program-tags';
import PropTypes from 'prop-types';
import { OrdersGridColumns } from '../../../../store/orders/grid/orders-grid-columns';
import { PremiumProgram } from '../../../../enums/premium-program';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './premium-programs.module.less';

const PremiumProgramsComponent = ({ fulfillmentPlanId }) => {
  const premiumPrograms = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'premiumPrograms') || emptyArray;
  const supportedPremiumPrograms = premiumPrograms.filter((premiumProgram) => PremiumProgram[premiumProgram]);

  if (supportedPremiumPrograms.length === 0) {
    return null;
  }

  if (supportedPremiumPrograms.length > 1) {
    return <Multiple />;
  }

  return (
    <div className={style['premium-programs-cell']}>
      <PremiumProgramTags premiumPrograms={premiumPrograms} />
    </div>
  );
};

PremiumProgramsComponent.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const PremiumPrograms = {
  getMessageDescriptor: () => messages.premiumPrograms,
  id: OrdersGridColumns.PremiumPrograms,

  render: (data, { isFirstOfType }) => {
    return isFirstOfType ? <PremiumProgramsComponent fulfillmentPlanId={data.id} /> : null;
  },
};
